import { useLanguage } from '../../contexts/language';
import { useSession } from '../../contexts/session';

import styles from './style.module.css';

// How a home page opens, the patient's Today and the clinician's Dashboard
// alike: the day, then a greeting with the person's first name. The greeting
// follows the device's clock: morning until noon, afternoon until six,
// evening after that and before five.
export function Greeting({ day }) {
  const { text, language } = useLanguage();
  const { me } = useSession();
  const hour = new Date().getHours();
  let greeting = text.goodEvening;

  if (hour >= 5 && hour < 12) {
    greeting = text.goodMorning;
  }

  if (hour >= 12 && hour < 18) {
    greeting = text.goodAfternoon;
  }

  const date = new Intl.DateTimeFormat(language, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }).format(new Date(`${ day }T00:00:00Z`));

  return (
    <div className={ styles.heading }>
      <span className={ styles.date }>{ date }</span>

      <h1 className={ styles.title }>{ greeting.replace('{name}', me.profile.firstName) }</h1>
    </div>
  );
}
